// Pure data and string builders for the TeamForm mark, shared by the React
// spinner and the static boot shell generated into index.html.

export const EDGE_LOOP =
  "M19.97 22.58 L47.5 12.12 L35.97 30.43 L19.97 22.58 L42.07 60.29 L35.97 30.43 L19.97 22.58";
export const EDGE_DRAW =
  "M19.97 22.58 L47.5 12.12 L35.97 30.43 L19.97 22.58 L42.07 60.29 L35.97 30.43";

export const MARK_HOLES = [
  { cx: 19.97, cy: 22.58, r: 5.22 },
  { cx: 47.5, cy: 12.12, r: 2.9 },
  { cx: 35.97, cy: 30.43, r: 2.9 },
  { cx: 42.07, cy: 60.29, r: 2.9 },
];

export const MARK_NODES = [
  { name: "hub", ...MARK_HOLES[0] },
  { name: "b", ...MARK_HOLES[1] },
  { name: "c", ...MARK_HOLES[2] },
  { name: "d", ...MARK_HOLES[3] },
];

const NODE_BASE = `
  .$node{fill:currentColor;animation-duration:var(--$dur);animation-timing-function:linear;animation-iteration-count:infinite}
  .$hub{animation-name:$-hub;transform-origin:19.97px 22.58px}
  .$b{animation-name:$-b;transform-origin:47.5px 12.12px}
  .$c{animation-name:$-c;transform-origin:35.97px 30.43px}
  .$d{animation-name:$-d;transform-origin:42.07px 60.29px}
`;

export const TEAMFORM_MARK_STYLES = {
  signal: `
    .$root{--$dur:3s}
    .$edge{stroke:currentColor;stroke-width:2;stroke-linejoin:round;opacity:.15}
    .$comet{stroke:var(--tfsp-accent,currentColor);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:96 904;stroke-dashoffset:1000;animation:$-travel var(--$dur) linear infinite}
    ${NODE_BASE}
    .$node{opacity:.35}
    .$hub{opacity:.5}
    @keyframes $-travel{to{stroke-dashoffset:0}}
    @keyframes $-hub{0%,33.2%{opacity:.5;transform:scale(1)}35.2%{opacity:1;transform:scale(1.12)}49.2%,90.4%{opacity:.5;transform:scale(1)}92.4%{opacity:1;transform:scale(1.12)}100%{opacity:.5;transform:scale(1)}}
    @keyframes $-b{0%,8.7%{opacity:.35;transform:scale(1)}10.7%{opacity:1;transform:scale(1.35)}24.7%,100%{opacity:.35;transform:scale(1)}}
    @keyframes $-c{0%,22.2%{opacity:.35;transform:scale(1)}24.2%{opacity:1;transform:scale(1.35)}38.2%,79.3%{opacity:.35;transform:scale(1)}81.3%{opacity:1;transform:scale(1.35)}95.3%,100%{opacity:.35;transform:scale(1)}}
    @keyframes $-d{0%,60.4%{opacity:.35;transform:scale(1)}62.4%{opacity:1;transform:scale(1.35)}76.4%,100%{opacity:.35;transform:scale(1)}}
    @media (prefers-reduced-motion:reduce){.$comet{display:none}.$node{animation:none;opacity:1}.$edge{opacity:.6}}
  `,
  assemble: `
    .$root{--$dur:4s}
    .$draw{stroke:var(--tfsp-accent,currentColor);stroke-width:2;stroke-opacity:.55;stroke-linejoin:round;stroke-dasharray:1000 1000;stroke-dashoffset:1000;animation:$-drawin var(--$dur) linear infinite}
    ${NODE_BASE}
    @keyframes $-drawin{0%{stroke-dashoffset:1000;opacity:1}55%{stroke-dashoffset:0;opacity:1}80%{stroke-dashoffset:0;opacity:1}90%,100%{stroke-dashoffset:0;opacity:0}}
    @keyframes $-hub{0%{opacity:0;transform:scale(.6)}3%{opacity:1;transform:scale(1.1)}8%{opacity:1;transform:scale(1)}80%{opacity:1;transform:scale(1)}90%,100%{opacity:0;transform:scale(1)}}
    @keyframes $-b{0%,11.3%{opacity:0;transform:scale(.4)}14.3%{opacity:1;transform:scale(1.2)}19.3%{opacity:1;transform:scale(1)}80%{opacity:1;transform:scale(1)}90%,100%{opacity:0;transform:scale(1)}}
    @keyframes $-c{0%,19.6%{opacity:0;transform:scale(.4)}22.6%{opacity:1;transform:scale(1.2)}27.6%{opacity:1;transform:scale(1)}80%{opacity:1;transform:scale(1)}90%,100%{opacity:0;transform:scale(1)}}
    @keyframes $-d{0%,43.3%{opacity:0;transform:scale(.4)}46.3%{opacity:1;transform:scale(1.2)}51.3%{opacity:1;transform:scale(1)}80%{opacity:1;transform:scale(1)}90%,100%{opacity:0;transform:scale(1)}}
    @media (prefers-reduced-motion:reduce){.$draw{animation:none;stroke-dashoffset:0}.$node{animation:none;opacity:1}}
  `,
  ripple: `
    .$root{--$dur:3s}
    .$edge{stroke:currentColor;stroke-width:2;stroke-linejoin:round;opacity:.15}
    .$ring{fill:none;stroke:var(--tfsp-accent,currentColor);stroke-width:1.2;vector-effect:non-scaling-stroke;transform-origin:19.97px 22.58px;animation:$-ripple var(--$dur) linear infinite}
    ${NODE_BASE}
    .$node{opacity:.35}
    .$hub{opacity:.5}
    @keyframes $-ripple{0%{transform:scale(6);opacity:.35}60%,100%{transform:scale(44);opacity:0}}
    @keyframes $-hub{0%{opacity:.5;transform:scale(1)}2%{opacity:1;transform:scale(1.1)}14%,100%{opacity:.5;transform:scale(1)}}
    @keyframes $-c{0%,18.6%{opacity:.35;transform:scale(1)}20.6%{opacity:1;transform:scale(1.3)}32.6%,100%{opacity:.35;transform:scale(1)}}
    @keyframes $-b{0%,37%{opacity:.35;transform:scale(1)}39%{opacity:1;transform:scale(1.3)}51%,100%{opacity:.35;transform:scale(1)}}
    @keyframes $-d{0%,59.5%{opacity:.35;transform:scale(1)}61.5%{opacity:1;transform:scale(1.3)}73.5%,100%{opacity:.35;transform:scale(1)}}
    @media (prefers-reduced-motion:reduce){.$ring{display:none}.$node{animation:none;opacity:1}.$edge{opacity:.6}}
  `,
};

/** Static SVG string for the "assemble" animation, for markup built outside React. */
export const getAssembleMarkSvg = ({ size, maskId = "tfsp-boot-holes" }) => {
  const prefix = "tfsp-assemble-";
  const css = TEAMFORM_MARK_STYLES.assemble.replace(/\$/g, prefix);
  const holes = MARK_HOLES.map(
    (h) => `<circle cx="${h.cx}" cy="${h.cy}" r="${h.r}" fill="black"/>`
  ).join("");
  const nodes = MARK_NODES.map(
    (n) =>
      `<circle class="${prefix}node ${prefix}${n.name}" cx="${n.cx}" cy="${n.cy}" r="${n.r}"/>`
  ).join("");
  return `<svg class="${prefix}root" width="${size}" height="${size}" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><style>${css}</style><mask id="${maskId}" maskUnits="userSpaceOnUse" x="0" y="0" width="70" height="70"><rect width="70" height="70" fill="white"/>${holes}</mask><g mask="url(#${maskId})"><path class="${prefix}draw" pathLength="1000" d="${EDGE_DRAW}"/></g>${nodes}</svg>`;
};
